import React from "react";
import Switch from "@ui/Switch";
import t from "../../../i18n";
import useSuspectedFailuresInExplanation from "../Diagnosis/useSuspectedFailuresInExplanation";

function ToggleSuspectedFailuresDisplay({ projectId }: { projectId: string }) {
  const [suspectedFailuresDisplay, setSuspectedFailuresDisplay] = useSuspectedFailuresInExplanation(
    {
      scope: projectId,
    },
  );

  return (
    <Switch
      checked={suspectedFailuresDisplay}
      onChange={() => setSuspectedFailuresDisplay(state => !state)}
    >
      {t("diagnosis.overview.legend.tooltip.unexplained_gap.integrate_suspected")}
    </Switch>
  );
}

export default React.memo(ToggleSuspectedFailuresDisplay);
